import { useContext } from "react";
import { AuthContext, LanguageContext } from "@/context";

function useLanguageContext(){
    return useContext(LanguageContext)
}

function useAuthContext(){
    return useContext(AuthContext);
}

export { useLanguageContext, useAuthContext };